import SolicitacaoContratacaoPessoal from './componentes/SolicitacaoContratacaoPessoal.vue';
import SolicitacaoContratacaoPessoalLista from './componentes/SolicitacaoContratacaoPessoalLista.vue';
import SolicitacaoContratacaoPessoalForm from './componentes/SolicitacaoContratacaoPessoalForm.vue';
import SolicitacaoContratacaoPessoalRelatorio from './componentes/SolicitacaoContratacaoPessoalRelatorio.vue';

export default {
  path: '/solicitacao-contratacao-pessoal',
  component: SolicitacaoContratacaoPessoal,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoContratacaoPessoalLista,
      name: 'solicitacao-contratacao-pessoal',
    },
    {
      path: 'nova',
      component: SolicitacaoContratacaoPessoalForm,
      name: 'solicitacao-contratacao-pessoal.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoContratacaoPessoalRelatorio,
      name: 'solicitacao-contratacao-pessoal.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoContratacaoPessoalForm,
      name: 'solicitacao-contratacao-pessoal.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-contratacao-pessoal/rotas.js